import React, { useEffect, useState, useRef } from 'react';
import { Switch } from "@curves/ui-base";
import { RolePermissionChangeConfirmationDialog } from '@icoach/club/dialog/';

const RolePermissionSwitchBox = React.forwardRef((props, ref) => {
    const { defaultValue: defaultValueProps = false, sourceData, headerLabel, permissionID, clubID } = props;
    const [checked, setChecked] = useState(false);
    const dialogRef = useRef(null);

    const handleOnChange = (_e, value) => {
        dialogRef.current.openDialog(value);
    };

    useEffect(
        () => {
            setChecked(Boolean(defaultValueProps));
        },
        // eslint-disable-next-line
        [defaultValueProps]
    );

    return (
        <React.Fragment>
            <Switch checked={checked} onChange={handleOnChange} />
            <RolePermissionChangeConfirmationDialog
                ref={dialogRef}
                setChecked={setChecked}
                sourceData={sourceData}
                editLabelText={headerLabel}
                permissionID={permissionID}
                clubID={clubID}
            />
        </React.Fragment>
    );
});

export default RolePermissionSwitchBox;
